import axios from "axios";
import { getApiConfig } from "../../apiConfig";

export async function DeleteCategoryResponsibles(categoryResponsible) {

    const apiConfig = await getApiConfig();

    const req = `${apiConfig.BASE_URL}categoryresponsible/${categoryResponsible}`;

    const response = await axios.delete(req, apiConfig.HEADERS_CONFIG, {
    });

    return response.data;
}